export default __webpack_public_path__ + "static/media/ic_services.e774f546.svg";